import React from 'react';
import './ChangeRequestsTableCTAs.less';
import { Result } from '../../../interfaces/changeRequest';
import ChangeRequestImportButton from '../ChangeRequestImportButton/ChangeRequestImportButton';
import { getReadonlyElementTitle } from '../../../services/subscription';
import ActionButton from '../../ActionButton/ActionButton';

interface ChangeRequestsTableCTAsProps {
  loading: boolean;
  selectedRows: Result[];
  isReadonly: boolean;
  onCreate: () => void;
  onBatchDelete: (selectedRows: Result[]) => void;
}

const ChangeRequestsTableCTAs: React.FC<ChangeRequestsTableCTAsProps> = ({
  loading,
  selectedRows,
  isReadonly,
  onCreate,
  onBatchDelete,
}) => {
  const isDisabled = loading || isReadonly;
  const hasSelectedRows = selectedRows.length > 0;
  let disabledMessageForDeleteBtn;
  if (isReadonly) {
    disabledMessageForDeleteBtn = getReadonlyElementTitle();
  } else if (!hasSelectedRows) {
    disabledMessageForDeleteBtn =
      'Select one or more change requests to delete';
  }

  return (
    <div className="cr-table-ctas">
      <ActionButton
        danger
        label="Delete"
        onClick={() => onBatchDelete(selectedRows)}
        disabled={loading || isReadonly || !hasSelectedRows}
        disabledMessage={disabledMessageForDeleteBtn}
      />
      <ChangeRequestImportButton disabled={isDisabled} label="Import (JSON)" />
      <ActionButton
        type="primary"
        label="Create"
        onClick={onCreate}
        disabled={isDisabled}
        disabledMessage={getReadonlyElementTitle()}
      />
    </div>
  );
};

export default ChangeRequestsTableCTAs;
